import { getApiRequest } from 'api/index';
import { ICalendarPlan } from 'types/calendarPlan';

export const getCalendarPlanList = (): Promise<Array<ICalendarPlan>> => {
    return getApiRequest(`/calendar-plan/`);
};
